import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context14, _context15; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context14 = ownKeys(Object(source), !0)).call(_context14, function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context15 = ownKeys(Object(source))).call(_context15, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _parseInt from "@babel/runtime-corejs3/core-js-stable/parse-int";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";

/* eslint-disable no-await-in-loop */

/* eslint-disable no-return-await */
import { API_TOKEN_EXPIRED_CODE, API_ACCESS_DENIED_CODE, UNAUTHORIZED_PATH, REALIZE_DEFAULT_ERROR_MESSAGE } from "../constants";
import { saveSessionStorageState, loadSessionStorageState } from "./sessionStorageHelper";
import { redirectTo } from "./browserHelper";
var apiHostUrl = process.env.REACT_APP_ALERTS_API_BASE_URL || process.env.REACT_APP_API_BASE_URL;
var ACCESS_TOKEN_EXPIRED_CODE = process.env.REACT_APP_ACCESS_TOKEN_EXPIRED_CODE && _parseInt(process.env.REACT_APP_ACCESS_TOKEN_EXPIRED_CODE) || API_TOKEN_EXPIRED_CODE;
var alertsServiceURLs = {
  common: "/realize/common/v1",
  eventmanagement: "/realize/eventmanagement/v1",
  accessTokenApiPath: "/realize/ransomwarerecovery/v1/auth"
};
alertsServiceURLs.licensing = "".concat(alertsServiceURLs.common, "/licensing");
alertsServiceURLs.console = "".concat(alertsServiceURLs.common, "/console");

var getAuthorizationHeader = function getAuthorizationHeader(apiToken) {
  return {
    Authorization: "Bearer ".concat(apiToken)
  };
};

export var getRequestUrl = function getRequestUrl(reqPath) {
  var _context, _context2;

  var service = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "common";
  var apiBaseUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : apiHostUrl;
  var pathprefix = arguments.length > 3 ? arguments[3] : undefined;

  var pathToAppend = _concatInstanceProperty(_context = "".concat(pathprefix || alertsServiceURLs[service], "/")).call(_context, reqPath);

  if (!apiBaseUrl) {
    return pathToAppend;
  }

  return _concatInstanceProperty(_context2 = "".concat(apiBaseUrl)).call(_context2, pathToAppend);
};

var defaultHeaders = function defaultHeaders() {
  return {
    "Content-Type": "application/json",
    "Cache-Control": "no-store, no-cache",
    pragma: "no-cache"
  };
};

export var isSuccessResponse = function isSuccessResponse(status) {
  return status >= 200 && status < 300;
};

var getQueryString = function getQueryString(params) {
  var queryString = []; // eslint-disable-next-line no-restricted-syntax

  for (var key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      var _context3;

      queryString.push(_concatInstanceProperty(_context3 = "".concat(key, "=")).call(_context3, params[key]));
    }
  }

  return queryString.join("&");
};

var throwError = function throwError() {
  var errorMsg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : REALIZE_DEFAULT_ERROR_MESSAGE;
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isEmptyResponse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var responseStatus = arguments.length > 3 ? arguments[3] : undefined;
  var error = isEmptyResponse ? new Error() : new Error(errorMsg);

  if (payload.message) {
    error = payload;
  } else {
    error = {
      message: errorMsg
    };
  }

  if (responseStatus === 500) {
    error.message = REALIZE_DEFAULT_ERROR_MESSAGE;
  }

  throw error;
};

var pause = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ms) {
    return _regeneratorRuntime.wrap(function _callee$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", new _Promise(function (r) {
              return _setTimeout(r, ms);
            }));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee);
  }));

  return function pause(_x) {
    return _ref.apply(this, arguments);
  };
}();

var handleApiResponse = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
    var fetchUrl, fetchOptions, method, reqPath, payload, optionalHeaders, counter, service, apiBaseUrl, pathprefix, accessTokenApiPath, parsedResponse, filename, response;
    return _regeneratorRuntime.wrap(function _callee2$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            fetchUrl = params.fetchUrl, fetchOptions = params.fetchOptions, method = params.method, reqPath = params.reqPath, payload = params.payload, optionalHeaders = params.optionalHeaders, counter = params.counter, service = params.service, apiBaseUrl = params.apiBaseUrl, pathprefix = params.pathprefix, accessTokenApiPath = params.accessTokenApiPath;
            _context5.next = 3;
            return fetch(fetchUrl, fetchOptions);

          case 3:
            response = _context5.sent;

            if (!(optionalHeaders["Content-Type"] === "text/csv")) {
              _context5.next = 12;
              break;
            }

            if (response.headers.get("content-disposition")) {
              filename = response.headers.get("content-disposition") && response.headers.get("content-disposition").split("=")[1];
            }

            _context5.next = 8;
            return response.text();

          case 8:
            parsedResponse = _context5.sent;
            parsedResponse = {
              filename: filename,
              data: parsedResponse
            };
            _context5.next = 15;
            break;

          case 12:
            _context5.next = 14;
            return response.json();

          case 14:
            parsedResponse = _context5.sent;

          case 15:
            if (!(response && response.status === ACCESS_TOKEN_EXPIRED_CODE)) {
              _context5.next = 18;
              break;
            }

            saveSessionStorageState({
              accessToken: null
            });
            return _context5.abrupt("return", getNewAccessToken(reqPath, payload, optionalHeaders, method, counter + 1, service, apiBaseUrl, pathprefix, accessTokenApiPath));

          case 18:
            if (!(response && response.status === API_ACCESS_DENIED_CODE)) {
              _context5.next = 21;
              break;
            }

            redirectTo("".concat(UNAUTHORIZED_PATH));
            return _context5.abrupt("return", throwError("405"));

          case 21:
            if (!response.ok) {
              _context5.next = 23;
              break;
            }

            return _context5.abrupt("return", parsedResponse);

          case 23:
            return _context5.abrupt("return", throwError(parsedResponse.message, parsedResponse, undefined, response.status));

          case 24:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee2);
  }));

  return function handleApiResponse(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

export var get = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3) {
    var _context6;

    var apiBaseUrl, pathprefix, reqPath, payload, _ref3$optionalHeaders, optionalHeaders, _ref3$counter, counter, service, accessTokenApiPath, queryString, fetchUrl, _loadSessionStorageSt, accessToken, authorizationHeader, headersForAPI, fetchOptions;

    return _regeneratorRuntime.wrap(function _callee3$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            apiBaseUrl = _ref3.apiBaseUrl, pathprefix = _ref3.pathprefix, reqPath = _ref3.reqPath, payload = _ref3.payload, _ref3$optionalHeaders = _ref3.optionalHeaders, optionalHeaders = _ref3$optionalHeaders === void 0 ? {} : _ref3$optionalHeaders, _ref3$counter = _ref3.counter, counter = _ref3$counter === void 0 ? 0 : _ref3$counter, service = _ref3.service, accessTokenApiPath = _ref3.accessTokenApiPath;
            queryString = "";

            if (payload) {
              queryString = "?".concat(getQueryString(payload));
            }

            if (counter > 3) {
              throwError(REALIZE_DEFAULT_ERROR_MESSAGE);
            }

            fetchUrl = _concatInstanceProperty(_context6 = "".concat(getRequestUrl(reqPath, service, apiBaseUrl, pathprefix))).call(_context6, queryString);
            _context7.prev = 5;

            if (!(loadSessionStorageState() && loadSessionStorageState().accessToken != null)) {
              _context7.next = 14;
              break;
            }

            _loadSessionStorageSt = loadSessionStorageState(), accessToken = _loadSessionStorageSt.accessToken;
            authorizationHeader = getAuthorizationHeader(accessToken);
            headersForAPI = _objectSpread(_objectSpread(_objectSpread({}, defaultHeaders()), optionalHeaders), authorizationHeader);
            fetchOptions = {
              method: "GET",
              headers: headersForAPI
            };
            _context7.next = 13;
            return handleApiResponse({
              method: "GET",
              fetchUrl: fetchUrl,
              fetchOptions: fetchOptions,
              reqPath: reqPath,
              payload: payload,
              optionalHeaders: optionalHeaders,
              counter: counter,
              service: service,
              apiBaseUrl: apiBaseUrl,
              pathprefix: pathprefix,
              accessTokenApiPath: accessTokenApiPath
            });

          case 13:
            return _context7.abrupt("return", _context7.sent);

          case 14:
            return _context7.abrupt("return", getNewAccessToken(reqPath, payload, optionalHeaders, "GET", counter + 1, service, apiBaseUrl, pathprefix, accessTokenApiPath));

          case 17:
            _context7.prev = 17;
            _context7.t0 = _context7["catch"](5);
            return _context7.abrupt("return", throwError());

          case 20:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee3, null, [[5, 17]]);
  }));

  return function get(_x3) {
    return _ref4.apply(this, arguments);
  };
}();
export var post = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref5) {
    var apiBaseUrl, pathprefix, reqPath, payload, _ref5$optionalHeaders, optionalHeaders, _ref5$counter, counter, service, accessTokenApiPath, fetchUrl, _loadSessionStorageSt2, accessToken, authorizationHeader, fetchOptions;

    return _regeneratorRuntime.wrap(function _callee4$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            apiBaseUrl = _ref5.apiBaseUrl, pathprefix = _ref5.pathprefix, reqPath = _ref5.reqPath, payload = _ref5.payload, _ref5$optionalHeaders = _ref5.optionalHeaders, optionalHeaders = _ref5$optionalHeaders === void 0 ? {} : _ref5$optionalHeaders, _ref5$counter = _ref5.counter, counter = _ref5$counter === void 0 ? 0 : _ref5$counter, service = _ref5.service, accessTokenApiPath = _ref5.accessTokenApiPath;
            fetchUrl = getRequestUrl(reqPath, service, apiBaseUrl, pathprefix);

            if (counter > 3) {
              throwError(REALIZE_DEFAULT_ERROR_MESSAGE);
            }

            _context8.prev = 3;

            if (!(loadSessionStorageState() && loadSessionStorageState().accessToken != null)) {
              _context8.next = 11;
              break;
            }

            _loadSessionStorageSt2 = loadSessionStorageState(), accessToken = _loadSessionStorageSt2.accessToken;
            authorizationHeader = getAuthorizationHeader(accessToken);
            fetchOptions = {
              method: "POST",
              headers: _objectSpread(_objectSpread(_objectSpread({}, defaultHeaders()), optionalHeaders), authorizationHeader),
              body: _JSON$stringify(payload)
            };
            _context8.next = 10;
            return handleApiResponse({
              method: "POST",
              fetchUrl: fetchUrl,
              fetchOptions: fetchOptions,
              reqPath: reqPath,
              payload: payload,
              optionalHeaders: optionalHeaders,
              counter: counter,
              service: service,
              apiBaseUrl: apiBaseUrl,
              pathprefix: pathprefix,
              accessTokenApiPath: accessTokenApiPath
            });

          case 10:
            return _context8.abrupt("return", _context8.sent);

          case 11:
            return _context8.abrupt("return", getNewAccessToken(reqPath, payload, optionalHeaders, "POST", counter + 1, service, apiBaseUrl, pathprefix, accessTokenApiPath));

          case 14:
            _context8.prev = 14;
            _context8.t0 = _context8["catch"](3);

            if (!_context8.t0.code) {
              _context8.next = 18;
              break;
            }

            return _context8.abrupt("return", throwError(_context8.t0.message, _context8.t0));

          case 18:
            return _context8.abrupt("return", throwError());

          case 19:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee4, null, [[3, 14]]);
  }));

  return function post(_x4) {
    return _ref6.apply(this, arguments);
  };
}();
export var put = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref7) {
    var apiBaseUrl, pathprefix, reqPath, payload, _ref7$optionalHeaders, optionalHeaders, _ref7$counter, counter, service, accessTokenApiPath, fetchUrl, fetchOptions, _loadSessionStorageSt3, accessToken, authorizationHeader, fetchHeaders;

    return _regeneratorRuntime.wrap(function _callee5$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            apiBaseUrl = _ref7.apiBaseUrl, pathprefix = _ref7.pathprefix, reqPath = _ref7.reqPath, payload = _ref7.payload, _ref7$optionalHeaders = _ref7.optionalHeaders, optionalHeaders = _ref7$optionalHeaders === void 0 ? {} : _ref7$optionalHeaders, _ref7$counter = _ref7.counter, counter = _ref7$counter === void 0 ? 0 : _ref7$counter, service = _ref7.service, accessTokenApiPath = _ref7.accessTokenApiPath;
            fetchUrl = getRequestUrl(reqPath, service, apiBaseUrl, pathprefix);
            fetchOptions = {
              method: "PUT",
              headers: _objectSpread(_objectSpread({}, defaultHeaders()), optionalHeaders),

              /** TODO : the function condiion is only for logout. remove if resolved */
              body: _JSON$stringify(typeof payload === "function" ? payload() : payload)
            };

            if (counter > 3) {
              throwError(REALIZE_DEFAULT_ERROR_MESSAGE);
            }

            if (!(loadSessionStorageState() && loadSessionStorageState().accessToken != null)) {
              _context9.next = 12;
              break;
            }

            _loadSessionStorageSt3 = loadSessionStorageState(), accessToken = _loadSessionStorageSt3.accessToken;
            authorizationHeader = getAuthorizationHeader(accessToken);
            fetchHeaders = _objectSpread(_objectSpread({}, fetchOptions.headers), authorizationHeader);
            fetchOptions.headers = fetchHeaders;
            _context9.next = 11;
            return handleApiResponse({
              method: "PUT",
              fetchUrl: fetchUrl,
              fetchOptions: fetchOptions,
              reqPath: reqPath,
              payload: payload,
              optionalHeaders: optionalHeaders,
              counter: counter,
              service: service,
              apiBaseUrl: apiBaseUrl,
              pathprefix: pathprefix,
              accessTokenApiPath: accessTokenApiPath
            });

          case 11:
            return _context9.abrupt("return", _context9.sent);

          case 12:
            return _context9.abrupt("return", getNewAccessToken(reqPath, payload, optionalHeaders, "PUT", counter + 1, service, apiBaseUrl, pathprefix, accessTokenApiPath));

          case 13:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee5);
  }));

  return function put(_x5) {
    return _ref8.apply(this, arguments);
  };
}();
export var del = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref9) {
    var _context10;

    var pathprefix, reqPath, payload, _ref9$optionalHeaders, optionalHeaders, _ref9$counter, counter, service, apiBaseUrl, accessTokenApiPath, queryString, fetchUrl, fetchOptions, _loadSessionStorageSt4, accessToken, authorizationHeader, fetchHeaders;

    return _regeneratorRuntime.wrap(function _callee6$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            pathprefix = _ref9.pathprefix, reqPath = _ref9.reqPath, payload = _ref9.payload, _ref9$optionalHeaders = _ref9.optionalHeaders, optionalHeaders = _ref9$optionalHeaders === void 0 ? {} : _ref9$optionalHeaders, _ref9$counter = _ref9.counter, counter = _ref9$counter === void 0 ? 0 : _ref9$counter, service = _ref9.service, apiBaseUrl = _ref9.apiBaseUrl, accessTokenApiPath = _ref9.accessTokenApiPath;
            queryString = "";

            if (payload) {
              queryString = "?".concat(getQueryString(payload));
            }

            if (counter > 3) {
              throwError(REALIZE_DEFAULT_ERROR_MESSAGE);
            }

            fetchUrl = _concatInstanceProperty(_context10 = "".concat(getRequestUrl(reqPath, service, apiBaseUrl, pathprefix))).call(_context10, queryString);
            fetchOptions = {
              method: "DELETE",
              headers: _objectSpread(_objectSpread({}, defaultHeaders()), optionalHeaders)
            };
            handleApi;

            if (!(loadSessionStorageState() && loadSessionStorageState().accessToken != null)) {
              _context11.next = 15;
              break;
            }

            _loadSessionStorageSt4 = loadSessionStorageState(), accessToken = _loadSessionStorageSt4.accessToken;
            authorizationHeader = getAuthorizationHeader(accessToken);
            fetchHeaders = _objectSpread(_objectSpread({}, fetchOptions.headers), authorizationHeader);
            fetchOptions.headers = fetchHeaders;
            _context11.next = 14;
            return handleApiResponse({
              method: "DELETE",
              fetchUrl: fetchUrl,
              fetchOptions: fetchOptions,
              reqPath: reqPath,
              payload: payload,
              optionalHeaders: optionalHeaders,
              counter: counter,
              service: service,
              apiBaseUrl: apiBaseUrl,
              pathprefix: pathprefix,
              accessTokenApiPath: accessTokenApiPath
            });

          case 14:
            return _context11.abrupt("return", _context11.sent);

          case 15:
            return _context11.abrupt("return", getNewAccessToken(reqPath, payload, optionalHeaders, "DELETE", counter + 1, service, apiBaseUrl, pathprefix, accessTokenApiPath));

          case 16:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee6);
  }));

  return function del(_x6) {
    return _ref10.apply(this, arguments);
  };
}();
export var getNewAccessToken = function () {
  var isAccessTokenBeingGenerated = false;
  return /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(reqPath, payload, optionalHeaders) {
      var method,
          counter,
          service,
          apiBaseUrl,
          pathprefix,
          accessTokenApiPath,
          _args7 = arguments;
      return _regeneratorRuntime.wrap(function _callee7$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              method = _args7.length > 3 && _args7[3] !== undefined ? _args7[3] : "GET";
              counter = _args7.length > 4 ? _args7[4] : undefined;
              service = _args7.length > 5 ? _args7[5] : undefined;
              apiBaseUrl = _args7.length > 6 ? _args7[6] : undefined;
              pathprefix = _args7.length > 7 ? _args7[7] : undefined;
              accessTokenApiPath = _args7.length > 8 ? _args7[8] : undefined;
              _context12.prev = 6;

            case 7:
              if (!true) {
                _context12.next = 27;
                break;
              }

              if (!isAccessTokenBeingGenerated) {
                _context12.next = 13;
                break;
              }

              _context12.next = 11;
              return pause(500);

            case 11:
              _context12.next = 25;
              break;

            case 13:
              if (!(!loadSessionStorageState() || !loadSessionStorageState().accessToken)) {
                _context12.next = 18;
                break;
              }

              // I am generating token
              isAccessTokenBeingGenerated = true;
              _context12.next = 17;
              return fetchAccessToken(accessTokenApiPath, apiBaseUrl);

            case 17:
              isAccessTokenBeingGenerated = false;

            case 18:
              _context12.t0 = method;
              _context12.next = _context12.t0 === "GET" ? 21 : _context12.t0 === "PUT" ? 22 : _context12.t0 === "DELETE" ? 23 : 24;
              break;

            case 21:
              return _context12.abrupt("return", get({
                apiBaseUrl: apiBaseUrl,
                pathprefix: pathprefix,
                reqPath: reqPath,
                payload: payload,
                optionalHeaders: optionalHeaders,
                counter: counter,
                service: service,
                accessTokenApiPath: accessTokenApiPath
              }));

            case 22:
              return _context12.abrupt("return", put({
                apiBaseUrl: apiBaseUrl,
                pathprefix: pathprefix,
                reqPath: reqPath,
                payload: payload,
                optionalHeaders: optionalHeaders,
                counter: counter,
                service: service,
                accessTokenApiPath: accessTokenApiPath
              }));

            case 23:
              return _context12.abrupt("return", del({
                apiBaseUrl: apiBaseUrl,
                pathprefix: pathprefix,
                reqPath: reqPath,
                payload: payload,
                optionalHeaders: optionalHeaders,
                counter: counter,
                service: service,
                accessTokenApiPath: accessTokenApiPath
              }));

            case 24:
              return _context12.abrupt("return", post({
                apiBaseUrl: apiBaseUrl,
                pathprefix: pathprefix,
                reqPath: reqPath,
                payload: payload,
                optionalHeaders: optionalHeaders,
                counter: counter,
                service: service,
                accessTokenApiPath: accessTokenApiPath
              }));

            case 25:
              _context12.next = 7;
              break;

            case 27:
              _context12.next = 32;
              break;

            case 29:
              _context12.prev = 29;
              _context12.t1 = _context12["catch"](6);
              return _context12.abrupt("return", throwError());

            case 32:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee7, null, [[6, 29]]);
    }));

    return function (_x7, _x8, _x9) {
      return _ref11.apply(this, arguments);
    };
  }();
}();
export var fetchAccessToken = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(accessTokenApiPath, apiBaseUrl) {
    var sessionStorage, _yield$accessTokenApi, accessToken, body, fetchOptions, response, parsedResponse, _parsedResponse$respo, _parsedResponse$respo2, _accessToken, redirectUrl;

    return _regeneratorRuntime.wrap(function _callee8$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            sessionStorage = loadSessionStorageState();

            if (!(sessionStorage && sessionStorage.accessToken)) {
              _context13.next = 3;
              break;
            }

            return _context13.abrupt("return", loadSessionStorageState());

          case 3:
            if (!(typeof accessTokenApiPath === "function")) {
              _context13.next = 17;
              break;
            }

            _context13.prev = 4;
            _context13.next = 7;
            return accessTokenApiPath();

          case 7:
            _yield$accessTokenApi = _context13.sent;
            accessToken = _yield$accessTokenApi.accessToken;

            if (accessToken) {
              saveSessionStorageState({
                accessToken: accessToken
              });
            }

            _context13.next = 15;
            break;

          case 12:
            _context13.prev = 12;
            _context13.t0 = _context13["catch"](4);
            console.error(_context13.t0);

          case 15:
            _context13.next = 41;
            break;

          case 17:
            body = _JSON$stringify({
              source_url: window.location.href || ""
            });
            fetchOptions = {
              method: "POST",
              headers: _objectSpread({}, defaultHeaders()),
              credentials: "same-origin",
              body: body
            };
            _context13.prev = 19;
            _context13.next = 22;
            return fetch(getRequestUrl("getAccessToken", "accessTokenApiPath", apiBaseUrl, accessTokenApiPath), fetchOptions);

          case 22:
            response = _context13.sent;
            _context13.next = 25;
            return response.json();

          case 25:
            parsedResponse = _context13.sent;

            if (!response.ok) {
              _context13.next = 35;
              break;
            }

            if (parsedResponse.error) {
              _context13.next = 34;
              break;
            }

            _accessToken = (_parsedResponse$respo = parsedResponse.response) === null || _parsedResponse$respo === void 0 ? void 0 : _parsedResponse$respo.accessToken;
            redirectUrl = (_parsedResponse$respo2 = parsedResponse.response) === null || _parsedResponse$respo2 === void 0 ? void 0 : _parsedResponse$respo2.redirectUrl;

            if (!(redirectUrl && (response.status === 401 || response.status === 403))) {
              _context13.next = 32;
              break;
            }

            return _context13.abrupt("return", redirectTo(redirectUrl));

          case 32:
            if (_accessToken) {
              saveSessionStorageState({
                accessToken: _accessToken
              });
            }

            return _context13.abrupt("return", parsedResponse);

          case 34:
            throwError(parsedResponse.error.message, parsedResponse.error);

          case 35:
            return _context13.abrupt("return", throwError(parsedResponse.error.message, parsedResponse.error));

          case 38:
            _context13.prev = 38;
            _context13.t1 = _context13["catch"](19);
            return _context13.abrupt("return", throwError());

          case 41:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee8, null, [[4, 12], [19, 38]]);
  }));

  return function fetchAccessToken(_x10, _x11) {
    return _ref12.apply(this, arguments);
  };
}();